module.exports = __webpack_public_path__ + "static/media/Infographie2.4ed05a50.jpg";